function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/table-cell-paragraph-post-fixer
 */

/**
 * Injects a table cell post-fixer into the model which inserts a `paragraph` element into empty table cells.
 *
 * A table cell must contain at least one block element as a child. An empty table cell will have an empty `paragraph` as a child.
 *
 *		<table>
 *			<tableRow>
 *				<tableCell></tableCell>
 *			</tableRow>
 *		</table>
 *
 * Will be fixed to:
 *
 *		<table>
 *			<tableRow>
 *				<tableCell><paragraph></paragraph></tableCell>
 *			</tableRow>
 *		</table>
 *
 * @param {module:engine/model/model~Model} model
 */
export default function injectTableCellParagraphPostFixer(model) {
  model.document.registerPostFixer(function (writer) {
    return tableCellContentsPostFixer(writer, model);
  });
} // The table cell contents post-fixer.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/model~Model} model

function tableCellContentsPostFixer(writer, model) {
  var changes = model.document.differ.getChanges();
  var wasFixed = false;

  var _iterator = _createForOfIteratorHelper(changes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var entry = _step.value;

      if (entry.type == 'insert' && entry.name == 'table') {
        wasFixed = fixTable(entry.position.nodeAfter, writer) || wasFixed;
      }

      if (entry.type == 'insert' && entry.name == 'tableRow') {
        wasFixed = fixTableRow(entry.position.nodeAfter, writer) || wasFixed;
      }

      if (entry.type == 'insert' && entry.name == 'tableCell') {
        wasFixed = fixTableCellContent(entry.position.nodeAfter, writer) || wasFixed;
      }

      if (checkTableCellChange(entry)) {
        wasFixed = fixTableCellContent(entry.position.parent, writer) || wasFixed;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return wasFixed;
} // Fixes all table cells in a table.
//
// @param {module:engine/model/element~Element} table
// @param {module:engine/model/writer~Writer} writer


function fixTable(table, writer) {
  var wasFixed = false;

  var _iterator2 = _createForOfIteratorHelper(table.getChildren()),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var row = _step2.value;

      if (row.is('element', 'tableRow')) {
        wasFixed = fixTableRow(row, writer) || wasFixed;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return wasFixed;
} // Fixes all table cells in a table row.
//
// @param {module:engine/model/element~Element} tableRow
// @param {module:engine/model/writer~Writer} writer


function fixTableRow(tableRow, writer) {
  var wasFixed = false;

  var _iterator3 = _createForOfIteratorHelper(tableRow.getChildren()),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var tableCell = _step3.value;
      wasFixed = fixTableCellContent(tableCell, writer) || wasFixed;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return wasFixed;
} // Fixes all table cell content by:
// - Adding a paragraph to a table cell without any child.
// - Wrapping direct $text in a `<paragraph>`.
//
// @param {module:engine/model/element~Element} table
// @param {module:engine/model/writer~Writer} writer
// @returns {Boolean}


function fixTableCellContent(tableCell, writer) {
  // Insert paragraph to an empty table cell.
  if (tableCell.childCount == 0) {
    // @if CK_DEBUG_TABLE // console.log( 'Post-fixing table: insert paragraph in empty cell.' );
    writer.insertElement('paragraph', tableCell);
    return true;
  } // Check table cell children for directly placed text nodes.
  // Temporary solution. See https://github.com/ckeditor/ckeditor5/issues/1464.


  var textNodes = Array.from(tableCell.getChildren()).filter(function (child) {
    return child.is('$text');
  }); // @if CK_DEBUG_TABLE // textNodes.length && console.log( 'Post-fixing table: wrap cell content with paragraph.' );

  var _iterator4 = _createForOfIteratorHelper(textNodes),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var child = _step4.value;
      writer.wrap(writer.createRangeOn(child), 'paragraph');
    } // Return true when there were text nodes to fix.

  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return !!textNodes.length;
} // Checks if a differ change should fix the table cell. This happens on:
// - Removing content from the table cell (i.e. `tableCell` can be left empty).
// - Adding a text node directly into a table cell.
//
// @param {Object} differ change entry
// @returns {Boolean}


function checkTableCellChange(entry) {
  if (!entry.position || !entry.position.parent.is('element', 'tableCell')) {
    return false;
  }

  return entry.type == 'insert' && entry.name == '$text' || entry.type == 'remove';
}